import { render } from "./z-files.vue?vue&type=template&id=f01fa1ac&scoped=true"
import script from "./z-files.vue?vue&type=script&lang=js"
export * from "./z-files.vue?vue&type=script&lang=js"

import "./z-files.vue?vue&type=style&index=0&id=f01fa1ac&lang=sass&scoped=true"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f01fa1ac"]])

export default __exports__